import { Collapse, Divider, Radio, Spin } from 'antd'
import { postCalculatePaidService, postCheckoutPaidService } from 'api/main/sponsor'
import CustomButton from 'components/atoms/custom-button'
import XenditBanksModal from 'components/organisms/Modal/XenditBanksModal'
import XenditResult from 'components/organisms/XenditResult'
import dayjs from 'dayjs'
import usePaymentMethod from 'hooks/Payment/usePaymentMethod'
import useXendit from 'hooks/Payment/useXendit'
import { ROLE_KEYS } from 'hooks/permissions/constant'
import React, { useEffect, useState } from 'react'
import { GoShieldCheck } from 'react-icons/go'
import { MdInfo } from 'react-icons/md'
import { useMutation, useQuery } from 'react-query'
import { Navigate, useLocation } from 'react-router-dom'
import { onCurrency, showErrorMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'
import { useNavigateBack } from 'hooks/useNavigateBack'
import { getSponsorship } from 'api/main/sponsor'

const sponsorType = {
  LANDING_PAGE: 'LANDING_PAGE',
  TOP_LISTING: 'TOP_LISTING',
  ADV_LANDING_PAGE_SPECIAL: "ADV_LANDING_PAGE_SPECIAL",
  ADV_LANDING_PAGE: "ADV_LANDING_PAGE",
  SNB_TOP_LIST: "SNB_TOP_LIST",
  SNB_LANDING_LIST: "SNB_LANDING_LIST"
}

const Sponsorship = () => {
  const navigateBack = useNavigateBack()

  const location = useLocation()
  const { user_package_subscription_id, profile_id, profile_type } = location.state || {}
  if (
    user_package_subscription_id == undefined ||
    profile_id == undefined ||
    profile_type == undefined
  ) {
    return <Navigate to={'/profile'} />
  }
  const [selectedSponsor, setSelectedSponsor] = useState(null)
  
  const {
    open,
    selectedBank,
    isResult,
    openModal,
    closeModal,
    handleSelectedBank,
    handleSuccessModal,
    getPaymentPayload
  } = usePaymentMethod()
  const { handlePay } = useXendit()
  const [detailPayment, setDetailPayment] = useState({})
  function handleSelectedSponsor(value) {
    setSelectedSponsor(value)
  }
  const postSubmitSponsorMutation = useMutation({
    mutationKey: 'postSubmitSponsorMutation',
    mutationFn: (payload) => postCheckoutPaidService(payload),
    onSuccess: () => {
      handleSuccessModal()
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })
  const postCalculateSponsorMutation = useMutation({
    mutationKey: 'postCalculateSponsorMutation',
    mutationFn: (payload) => postCalculatePaidService(payload),
    onSuccess: (res) => {
      const data = res?.data
      handleSetDetailPaymentSponsor(data)
    },
    onError: () => {}
  })
   const { data: sponsorshipResponse } = useQuery({
      queryKey: ['getSponsorship', profile_type],
      queryFn: () =>
         getSponsorship(profile_type !== ROLE_KEYS.ADVISOR ? 'buyer-seller' : 'advisor'),
      enabled: !!profile_type,
      retry: false,
      refetchOnWindowFocus: false,
   })
  function getPayloadSponsorship() {
    return {
      paid_service_type: 'SPONSORSHIP',
      sponsorship: {
        sponsorship_type: selectedSponsor[0],
        user_package_subscription_id: user_package_subscription_id,
        profile_type: profile_type,
        profile_id: profile_id
      }
    }
  }
  function handleSetDetailPaymentSponsor(data) {
    return setDetailPayment({
      paymentList: [
        {
          label: `${data?.paid_service?.sponsorship?.package?.name} x 1`,
          value: data?.paid_service?.sponsorship?.package?.price
        }
      ],
      paymentDetail: [
        { label: 'Sub Total', value: data?.sub_total_amount },
        ...(data?.service_cost_amount && data?.service_cost_amount > 0
          ? [
              {
                label: 'Biaya Layanan',
                value: data?.service_cost_amount
              }
            ]
          : []),
        { label: `PPN ${data?.ppn_percentage}%`, value: data?.ppn_amount }
      ],
      total: data?.total_amount
    })
  }

   useEffect(() => {
      if (
         selectedSponsor &&
         user_package_subscription_id &&
         profile_id &&
         profile_type
      ) {
         const payload = { paid_service: getPayloadSponsorship() }
         postCalculateSponsorMutation.mutate(payload)
      }
   }, [selectedSponsor])
   
  function handleSubmitSponsor() {
    const payload = {
      paid_service: getPayloadSponsorship(),
      payment: getPaymentPayload()
    }
    postSubmitSponsorMutation.mutate(payload)
  }

  return (
    <section className="py-16 h-full p-4 md:p-0 max-w-[480px] w-full mx-auto">
      {isResult ? (
        <XenditResult
          resultData={postSubmitSponsorMutation?.data?.data}
          handleClickPay={() => {
            const shortTransaction = postSubmitSponsorMutation?.data?.data?.transaction
            handlePay(shortTransaction?.reference_id, shortTransaction?.total_amount)
          }}
        />
      ) : (
         <>
            {/* Checkout */}
            <h1 className="mb-12 font-medium text-3xl">Checkout</h1>
            {/* Sponsored Details */}
            <SponsoredDetail
               sponsorshipList={sponsorshipResponse?.data}
               handleSelectedSponsor={handleSelectedSponsor}
               selectedSponsor={selectedSponsor}
               isCalculateLoading={postCalculateSponsorMutation?.isLoading}
               resultCalculateSponsor={postCalculateSponsorMutation?.data?.data}
            />
            {/* Payment Details */}
            {
               selectedSponsor === null || selectedSponsor.length === 0 ? null : (
                  <>
                     <div className="mt-6 grid grid-cols-1 gap-y-2">
                        <h2 className="text-base font-medium text-primary">Detail Pembayaran</h2>
                        <div className="border text-sm border-lighter border-solid rounded-lg p-6 gap-y-4 grid grid-cols-1 w-full">
                        {postCalculateSponsorMutation?.isLoading ? (
                           <SpinLoading />
                        ) : (
                           <>
                              {/* Payment List */}
                              {detailPayment?.paymentList?.map((data, index) => (
                              <div className="grid grid-flow-col w-full" key={index}>
                                 <span>{data?.label}</span>
                                 <span className="justify-self-end">{onCurrency(data?.value)}</span>
                              </div>
                              ))}
                              <Divider dashed className="m-0 border-lighter" />
                              {/* Detail Payment */}
                              {detailPayment?.paymentDetail?.map((data, index) => (
                              <div className="grid grid-cols-2" key={index}>
                                 <span>{data?.label}</span>
                                 <span className="justify-self-end">{onCurrency(data?.value)}</span>
                              </div>
                              ))}
                              {/* Total */}
                              <Divider dashed className="m-0 border-lighter" />
                              <div className="grid grid-cols-2">
                              <span className="font-medium">Total</span>
                              <span className="justify-self-end font-medium">
                                 {onCurrency(detailPayment?.total)}
                              </span>
                              </div>
                           </>
                        )}
                        </div>
                     </div>
                     <div className="w-full flex justify-end items-center gap-4 mt-6 mb-16">
                        <CustomButton onClick={navigateBack} type="plain" className="border-none shadow-none">
                        Batal
                        </CustomButton>
                        <CustomButton icon={<GoShieldCheck />} onClick={openModal} type="primary">
                        <span>Bayar</span>
                        </CustomButton>
                     </div>
                  </>
               )
            }
         </>
      )}

      {open ? (
        <XenditBanksModal
          isSubmitLoading={postSubmitSponsorMutation?.isLoading}
          open={open}
          selectedBank={selectedBank}
          onClose={closeModal}
          handleNext={handleSubmitSponsor}
          handleSelectedBank={handleSelectedBank}
        />
      ) : null}
    </section>
  )
}
function SponsoredDetail({
  selectedSponsor,
  handleSelectedSponsor,
  isCalculateLoading,
  resultCalculateSponsor,
  sponsorshipList
}) {
  return (
    <div className="grid grid-cols-1 gap-2">
      <h2 className="text-base font-medium">Detail Sponsor</h2>

      <Collapse
        bordered={false}
        accordion
        activeKey={selectedSponsor || undefined}
        className="grid grid-cols-1 gap-2 bg-white"
        onChange={(key) => {
          if (!key) return
          handleSelectedSponsor(key)
        }}
      >
        {sponsorshipList?.map((pkg) => {
          const isActive = selectedSponsor !== null ? selectedSponsor[0] === pkg.package_type : false
          const contentData =
            isActive && resultCalculateSponsor
              ? resultCalculateSponsor
              : null

          return (
            <Collapse.Panel
              key={pkg.package_type}
              collapsible={isActive ? "disabled" : undefined}
              showArrow={false}
              className={`border border-solid bg-white rounded-lg ${
                isActive ? 'border-info' : 'border-lighter'
              }`}
              header={
                <div className="grid grid-cols-[20px_1fr] items-start gap-2">
                  <Radio checked={isActive} />
                  <div>
                    <h3 className="text-primary font-medium text-sm">
                      {wording[pkg.package_type]?.title || pkg.name}
                    </h3>
                    <p className="text-xs text-secondary">
                      {wording[pkg.package_type]?.subtitle}
                    </p>
                  </div>
                </div>
              }
            >
              {isCalculateLoading && isActive ? (
                <SpinLoading />
              ) : (
                <div className="grid grid-cols-1 gap-4">
                  {/* Duration */}
                  <div className="flex flex-col gap-1 border border-solid border-lighter rounded-lg p-3">
                    <h4 className="text-sm text-secondary font-normal">
                      Durasi
                    </h4>
                    <div className="flex justify-between gap-1">
                      <p className="font-medium text-primary">
                        {contentData
                          ? contentData?.paid_service?.sponsorship?.package
                              ?.period
                          : pkg.duration}{' '}
                        Hari
                      </p>
                      <span className="font-medium text-primary">
                        {onCurrency(
                          contentData
                            ? contentData?.paid_service?.sponsorship?.package
                                ?.price
                            : pkg.price
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Warning */}
                  {wording[pkg.package_type]?.description && (
                    <div className="grid grid-cols-[20px_1fr] gap-2 bg-surface-warning-light p-2 rounded-lg">
                      <MdInfo
                        className="text-surface-warning-dark"
                        size={20}
                      />
                      <p className="text-xs font-normal">
                        {wording[pkg.package_type]?.description}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </Collapse.Panel>
          )
        })}
      </Collapse>
    </div>
  )
}
function SpinLoading() {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <Spin spinning size="large"></Spin>
    </div>
  )
}

function CollapseHeaderLandingPage({ selectedSponsor }) {
  return (
    <div className="grid grid-cols-[20px_1fr] items-start gap-2">
      {/* else nya pakai yang ini */}
      <Radio className="mt-0.5" checked={selectedSponsor == sponsorType.LANDING_PAGE}></Radio>
      <div>
         {/* ambil dari item.name */}
        <h3 className="text-primary font-medium text-sm">Ditampilkan di Halaman Utama</h3>
        {/* ambil dari word[package_type].subtitle */}
        <p className="text-xs text-secondary">Profil Anda akan ditampilkan di halaman utama.</p>
      </div>
    </div>
  )
}
function CollapseContentLandingPage({ data }) {
  return (
    <div className="grid grid-cols-1 gap-4">
      {/* Duration */}
      <div className="flex flex-col gap-1 border border-solid border-lighter rounded-lg p-3">
        <h4 className="text-sm text-secondary font-normal">Durasi</h4>
        <div className="flex justify-between gap-1">
          <p className="font-medium text-primary">
            {/* ambil dari item.duration */}
            {data?.paid_service?.sponsorship?.package?.period} Hari
          </p>
          {/* ambil dari item.price */}
          <span className="font-medium text-primary">
            {onCurrency(data?.paid_service?.sponsorship?.package?.price)}
          </span>
        </div>
      </div>
      {/* Warning Info */}
      <div className="grid grid-cols-[20px_1fr] gap-2 bg-surface-warning-light p-2 rounded-lg">
        <MdInfo className="text-surface-warning-dark" size={20} />
        {/* ambil dari word[package_type].description */}
        <p className="text-xs font-normal">
          Karena slot terbatas, profil sponsor akan ditampilkan secara bergantian dengan jeda 5
          detik.
        </p>
      </div>
    </div>
  )
}
function CollapseHeaderTopListing({ selectedSponsor }) {
  return (
    <div className="grid grid-cols-[20px_1fr] items-start gap-2">
      <Radio className="mt-0.5" checked={selectedSponsor == sponsorType.TOP_LISTING}></Radio>
      <div>
        <h3 className="text-primary font-medium text-sm">Daftar Teratas di Halaman Listing</h3>
        <p className="text-xs text-secondary">
          Profil Anda akan ditampilkan pada daftar teratas di halaman listing.
        </p>
      </div>
    </div>
  )
}
function CollapseContentTopListing({ data }) {
  return (
    <>
      <div className="flex flex-col gap-1 border border-solid border-lighter rounded-lg p-3">
        <h4 className="text-sm text-secondary font-normal">Durasi</h4>
        <div className="flex justify-between gap-1">
          <p className="font-medium text-primary">
            {data?.paid_service?.sponsorship?.package?.period} Hari
          </p>
          {/* ambil dari item.price */}
          <span className="font-medium text-primary">
            {onCurrency(data?.paid_service?.sponsorship?.package?.price)}
          </span>
        </div>
      </div>
      <div className="grid place-items-center grid-cols-1 mt-4 gap-1 border border-solid border-lighter rounded-lg p-3">
        <h4 className="font-normal text-xs text-secondary">Tanggal Penayangan</h4>
        <p className="font-medium text-primary text-sm">
          {dayjs(data?.paid_service?.sponsorship?.estimated_start_time).format('DD/MM/YYYY')} -{' '}
          {dayjs(data?.paid_service?.sponsorship?.estimated_end_time).format('DD/MM/YYYY')}{' '}
          {/* ambil dari item.duration */}
          <span className="text-secondary font-normal text-sm">
            ({data?.paid_service?.sponsorship?.package?.period} hari)
          </span>
        </p>
        {/* Warning Info */}
        <div className="grid grid-cols-[20px_1fr] items-center gap-2 bg-info-light mt-2 p-2 rounded-lg">
          <MdInfo className="text-info" size={20} />
          {/* ambil dari word[package_type].description */}
          <p className="text-xs font-normal">
            Profil sponsor akan aktif setelah pembayaran berhasil.
          </p>
        </div>
      </div>
    </>
  )
}

const wording = {
   "ADV_LANDING_PAGE_SPECIAL": {
      title: 'Ditampilkan di Spesial Konten',
      subtitle: 'Profil Anda akan ditampilkan di spesial konten.',
      description: 'Profil yang disetujui aktif selama 7 hari sejak aktivasi. Periode ini tetap berjalan meskipun profil tidak selalu tampil di Special Spot. Penayangan diatur secara rotasi oleh Admin sesuai ketersediaan dan kebijakan.'
   },
   "ADV_LANDING_PAGE": {
      title: 'Ditampilkan di Halaman Utama',
      subtitle: 'Profil Anda akan ditampilkan di halaman utama.',
      description: 'Karena slot terbatas, profil sponsor akan ditampilkan secara bergantian dengan jeda 5 detik.'
   },
   "SNB_TOP_LIST": {
      title: 'Daftar Teratas di Halaman Listing',
      subtitle: 'Profil Anda akan ditampilkan pada daftar teratas di halaman listing.',
      description: 'Profil sponsor akan aktif setelah pembayaran berhasil.'
   },
   "SNB_LANDING_PAGE": {
      title: 'Daftar Teratas di Halaman Utama',
      subtitle: 'Profil Anda akan ditampilkan pada daftar teratas di halaman utama.',
      description: 'Profil sponsor akan aktif setelah pembayaran berhasil.'
   },
}

export default Sponsorship
